import React, { useEffect, useState } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Home',
    href: '#home'
  }, {
    name: 'About',
    href: '#about'
  }, {
    name: 'Varieties',
    href: '#varieties'
  }, {
    name: 'Processing',
    href: '#processing'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-brand-black/95 backdrop-blur-sm py-2 shadow-lg' : 'bg-transparent py-4'}`} data-id="element-110">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-111">
        <div className="flex justify-between items-center" data-id="element-112">
          {/* Logo */}
          <a href="#home" className="flex-shrink-0" data-id="element-113">
            <img src="https://cdn.magicpatterns.com/uploads/tVa16v8wUNH1AWqM4qenaa/Asset_1_(1).png" alt="Blazing Barry's Coffee" className="h-12 md:h-16 w-auto object-contain" data-id="element-114" />
          </a>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-115">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-white hover:text-brand-red font-display tracking-wide uppercase text-sm font-medium transition-colors duration-200" data-id="element-116">
                {link.name}
              </a>)}
            <div className="flex items-center text-brand-red font-display font-bold ml-4" data-id="element-117">
              <Phone className="w-4 h-4 mr-2" data-id="element-118" />
              <span data-id="element-119">+254 743 287 924</span>
            </div>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden" data-id="element-120">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-white hover:text-brand-red transition-colors p-2" aria-label="Toggle menu" data-id="element-121">
              {isMobileMenuOpen ? <X size={28} data-id="element-122" /> : <Menu size={28} data-id="element-123" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu Drawer */}
      <AnimatePresence data-id="element-124">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-brand-black border-t border-gray-800" data-id="element-125">
            <div className="px-4 pt-4 pb-8 space-y-4 flex flex-col items-center" data-id="element-126">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="text-white hover:text-brand-red font-display text-xl uppercase tracking-wider py-2" data-id="element-127">
                  {link.name}
                </a>)}
              <div className="pt-4 border-t border-gray-800 w-full text-center" data-id="element-128">
                <a href="tel:+254743287924" className="text-brand-red font-display font-bold flex items-center justify-center" data-id="element-129">
                  <Phone className="w-5 h-5 mr-2" data-id="element-130" />
                  +254 743 287 924
                </a>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}